import React from 'react'

export default function StartNewsLetter() {
    return (
        <>
            <section className="news-letter-section" id="news-letter-section">
                <div className="row ">
                    <div className="container">
                        <div className="news-letter-wrap wow zoomIn">
                            <div className="news-letter-image">
                                <img src="./images/news-letter-image1.png" />
                            </div>
                            <div className="news-letter-text">
                                <div className="title">
                                    <h2>Send Us Your Newsletter
                                        and <span className="red">We’ll Handle The Rest.</span> </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
